import { qualityImage, qualityTiers } from "@/mocks/home";

export default function Quality() {
  const notes = [
    {
      icon: "ri-hard-drive-2-line",
      title: "缓存与下载分开管理",
      desc: "边看边缓存的进度会保留在本地，主动下载则会把整集保存到设备，方便出行后离线播放。",
    },
    {
      icon: "ri-signal-tower-line",
      title: "弱网自动降档",
      desc: "当网络波动时，播放器会先降到较低清晰度保证连贯，等网络恢复后可手动切回高清档位。",
    },
    {
      icon: "ri-refresh-line",
      title: "进度自动续播",
      desc: "正常退出后再次打开，通常可以从上次的位置继续，不需要重新拖动进度条。",
    },
  ];

  return (
    <section id="quality" className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-accent-700">
            <i className="ri-hd-line"></i>
            画质与缓存
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            高清播放的分档与数据参考
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            清晰度越高画面越细腻，但对带宽和存储的要求也更高。下表给出常见档位的参考信息，
            可以根据所处环境灵活选择，不必一味追求最高画质。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-5">
          <div className="lg:col-span-2 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="overflow-x-auto">
              <table className="w-full min-w-[560px] text-left text-sm">
                <thead className="bg-background-200/70">
                  <tr>
                    <th className="px-4 md:px-5 py-3 font-medium text-foreground-700">清晰度</th>
                    <th className="px-4 md:px-5 py-3 font-medium text-foreground-700">分辨率</th>
                    <th className="px-4 md:px-5 py-3 font-medium text-foreground-700">适合场景</th>
                    <th className="px-4 md:px-5 py-3 font-medium text-foreground-700">参考用量</th>
                  </tr>
                </thead>
                <tbody>
                  {qualityTiers.map((tier) => (
                    <tr
                      key={tier.id}
                      className="border-t border-background-200 hover:bg-background-100"
                    >
                      <td className="px-4 md:px-5 py-4">
                        <span className="inline-flex items-center gap-2 font-medium text-foreground-950">
                          <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                          {tier.label}
                        </span>
                      </td>
                      <td className="px-4 md:px-5 py-4 text-foreground-700">{tier.resolution}</td>
                      <td className="px-4 md:px-5 py-4 text-foreground-600">{tier.scene}</td>
                      <td className="px-4 md:px-5 py-4 text-foreground-600">{tier.data}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p className="px-4 md:px-5 py-4 text-xs text-foreground-500 border-t border-background-200">
              参考用量为估算值，实际消耗会因码率、片长与编码方式不同而有所变化。
            </p>
          </div>

          <div className="rounded-lg overflow-hidden border border-background-200 bg-background-50">
            <div className="relative w-full h-[180px]">
              <img
                src={qualityImage}
                alt="高清电视屏幕上播放的明亮画面"
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>
            <div className="p-5">
              <h3 className="font-heading text-lg font-bold text-foreground-950">
                关于缓存与下载
              </h3>
              <ul className="mt-3 space-y-3">
                {notes.map((note) => (
                  <li key={note.title} className="flex gap-3">
                    <span className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800 shrink-0">
                      <i className={`${note.icon} text-base`}></i>
                    </span>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{note.title}</p>
                      <p className="mt-0.5 text-xs text-foreground-600 leading-relaxed">
                        {note.desc}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}